<template>
  <div v-if="user!==null">


    <div
      v-if="user.ownUser"
      style="border: 1px solid #f0f9eb; border-left: 5px solid #67c23a; padding: 10px 20px 0px 20px;border-radius: 3px;margin-bottom: 25px;background-color: #eff8eb;"
    >
      <div style="margin-bottom: 15px; color: #67c23a; ">
        <b>Sprememba podatkov</b>
      </div>
      <el-form
        :model="dataChange"
        status-icon
        :rules="dataChangeRules"
        ref="dataChangeForm"
        label-width="110px"
        size="mini"
        label-position="left"
        :inline-message="true"
      >
        <el-form-item prop="email" style="margin-bottom:5px;">
          <template slot="label">
            <span style="font-weight: normal;">E-mail</span>
          </template>
          <el-input type="text" v-model="dataChange.email" autocomplete="off" disabled/>
        </el-form-item>
        <el-form-item prop="gsm" style="margin-bottom:5px;">
          <template slot="label">
            <span style="font-weight: normal;">GSM</span>
          </template>
          <el-input type="text" v-model="dataChange.gsm" autocomplete="off"/>
        </el-form-item>
        <el-form-item style="text-align: right;" label-width="0px">
          <el-button type="primary" @click="submitFormDataChange" :loading="loadingChangeData">Spremeni</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      v-if="user.ownUser"
      style="border: 1px solid #f0f9eb; border-left: 5px solid #67c23a; padding: 10px 20px;border-radius: 3px;margin-bottom: 25px;background-color: #eff8eb;"
    >
      <el-form
        :model="passChange"
        status-icon
        :rules="passChangeRules"
        ref="passChangeForm"
        label-width="110px"
        size="mini"
        label-position="left"
        :inline-message="true"
      >
        <div style="margin-bottom: 15px; color: #67c23a; ">
          <b>Sprememba gesla</b>
        </div>
        <el-form-item prop="oldPassword" style="margin-bottom:5px;">
          <template slot="label">
            <span style="font-weight: normal;">Staro geslo</span>
          </template>
          <el-input type="password" v-model="passChange.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword" style="margin-bottom:5px;">
          <template slot="label">
            <span style="font-weight: normal;">Novo geslo</span>
          </template>
          <el-input type="password" v-model="passChange.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="reenterNewPassword" style="margin-bottom:5px;">
          <template slot="label">
            <span style="font-weight: normal;">Potrditev gesla</span>
          </template>
          <el-input type="password" v-model="passChange.reenterNewPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right; margin-bottom: 5px;" label-width="0px">
          <el-button @click="resetForm('passChangeForm')">Ponastavi</el-button>
          <el-button type="primary" @click="submitFormPassChange" :loading="loadingChangePassword">Spremeni geslo</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      v-if="user.ownUser"
      style="margin-bottom: 25px;background-color: #fdf6ec; color: #e6a23c; border-left: 5px solid #e6a23c; padding: 10px 20px;border-radius: 3px">
      <div style="margin-bottom: 5px;margin-bottom: 15px;" v-if="!ponastaviGesloDetails">
        <b>Pozabljeno geslo</b>
      </div>
      <div style="word-break: break-word;" v-if="!ponastaviGesloDetails">
        Ste pozabili geslo? <br>Lahko si ga ponastavite. Novo geslo vnesete preko obrazca, nato pa preko SMS-a dobite potrditveni PIN, s katerim lahko zaključite postopek.
      </div>
      <div style="text-align: right; margin-top:15px;" v-if="!ponastaviGesloDetails">
        <el-button type="warning" size="mini" @click="ponastaviGesloDetails = true">
          Ponastavitev gesla
        </el-button>
      </div>

      <div style="margin-bottom: 5px;margin-bottom: 15px;" v-if="ponastaviGesloDetails">
        <b>Ponastavi geslo</b>
      </div>
      <el-form
        :model="passReset"
        status-icon
        :rules="passResetRules"
        ref="passResetForm"
        label-width="110px"
        size="mini"
        label-position="left"
        v-if="ponastaviGesloDetails"
        :inline-message="true"
      >
        <el-form-item prop="newPassword" style="margin-bottom:5px;">
          <template slot="label">
            <span style="font-weight: normal;">Novo geslo</span>
          </template>
          <el-input type="password" v-model="passReset.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="reenterNewPassword" style="margin-bottom:5px;">
          <template slot="label">
            <span style="font-weight: normal;">Potrditev gesla</span>
          </template>
          <el-input type="password" v-model="passReset.reenterNewPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="pin" style="margin-bottom:5px;">
          <template slot="label">
            <span style="font-weight: normal;">PIN</span>
          </template>
          <div style="display: flex">
            <el-input type="text" v-model="passReset.pin" autocomplete="off"
                      style="flex:auto;"></el-input>
            <div style="text-align: right;margin-left: 10px;">
              <el-button size="mini" v-if="pinPoslan === null" @click="posliPin" :loading="loadingPosljiPin">
                Pošlji PIN
              </el-button>
              <div v-if="pinPoslan !== null" style="width: 50px; color:black">{{ pinRenewLabel }}</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item style="text-align: right; margin-bottom: 5px;" label-width="0px">
          <el-button @click="resetForm('passResetForm')">Ponastavi</el-button>
          <el-button type="warning" @click="submitFormPassReset" :loading="loadingResetPassword">Nastavi geslo
          </el-button>
        </el-form-item>
      </el-form>


    </div>

    <div id="odstraniUporabnikaSProjekta" v-if="project !== null">
      <div style="margin-bottom: 5px;">
        <b>Odstranitev uporabnika s projekta {{ project.name }}</b>
      </div>
      <div style="word-break: break-word;">
        Če izberete to možnost, potem bo uporabnik odstranjen s projekta.
        Uporabnik se bo še vedno lahko prijavil v cloud, vendar ne bo imel dostopa do dotičnega projekta.
      </div>
      <div style="text-align: right;" v-if="!odstraniSProjektaConfirm">
        <el-button type="danger" size="mini" @click="odstraniSProjektaConfirm = true">
          Odstrani uporabnika s projekta
        </el-button>
      </div>
      <div v-if="odstraniSProjektaConfirm">
        <div style="margin: 10px 0px 0px 0px;">Ste prepričani, da želite uporabnika odstraniti s
          projekta
          <b>{{ project.name }}</b>
          ?
        </div>
        <div style="text-align: right;">
          <el-button
            type="danger"
            size="mini"
            style="margin: 10px 0px 0px 0px;"
            @click="odstraniUporabnikaSProjekta"
            :loading="loadingRemoveUserFromProject"
          >{{ removeUserFromProjectConfirmButton }}
          </el-button>
          <el-button type="primary" size="mini" @click="odstraniSProjektaConfirm = false"
                     style="margin: 10px 0px 0px 0px;">
            NE, uporabnika želim obdržati
          </el-button>
        </div>
      </div>
    </div>

<!--    <div-->
<!--      style="background-color: #fdefea; color: #EB5E28; border-left: 5px solid #EB5E28; padding: 10px 20px;border-radius: 3px"-->
<!--      v-if="user.ownUser"-->
<!--    >-->
<!--      <div style="margin-bottom: 5px;">-->
<!--        <b>Brisanje uporabnika</b>-->
<!--      </div>-->
<!--      <div style="word-break: break-word;">-->
<!--        Če se odločite za izbris uporabnika, bo ta odstranjen na vseh projekti. Uporabnika ne bo mogoče obnoviti!-->
<!--      </div>-->
<!--      <div style="margin: 15px 0px;">Ste prepričani da želite nadaljevati?</div>-->
<!--      <div style="text-align: right;">-->
<!--        <el-button type="danger" size="mini">-->
<!--          Da, odstrani uporabnika (še ne deluje)-->
<!--        </el-button>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>

import {Alert, Button, Form, Input, Divider} from 'element-ui'
import CloudUser from '../../../../../assets/js/T2Cloud/CloudUser'
import {CloudProject} from '../../../../../assets/js/T2Cloud/CloudProject'

export default {
  name: 'CloudUserEdit',
  components: {
    [Alert.name]: Alert,
    [Button.name]: Button,
    [Form.name]: Form,
    [Input.name]: Input,
    [Divider.name]: Divider
  },
  props: {
    user: {
      type: CloudUser,
      required: true
    },
    project: {
      type: CloudProject,
      required: false,
      default: null
    }
  },
  data () {
    return {
      ponastaviGesloDetails: false,
      pinPoslan: null,
      pinInterval: null,
      pinRenewLabel: '',
      passChange: {
        oldPassword: '',
        newPassword: '',
        reenterNewPassword: ''
      },
      dataChange: {
        email: this.user.email,
        gsm: this.user.gsm
      },
      dataChangeRules: {
        email: [],
        gsm: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'},
          {validator: this.formValidation.inputSloGsmValidation, trigger: 'change'}
        ]
      },
      passChangeRules: {
        oldPassword: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'}
        ],
        newPassword: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'},
          {validator: this.passwordCharsRule, trigger: 'change'}
        ],
        reenterNewPassword: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'},
          {validator: this.passwordCharsRule, trigger: 'change'},
          {validator: this.passwordsMatchRule, trigger: 'change'}
        ]
      },
      passReset: {
        pin: '',
        newPassword: '',
        reenterNewPassword: ''
      },
      passResetRules: {
        newPassword: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'blur'},
          {validator: this.passwordCharsRule, trigger: 'blur'}
        ],
        reenterNewPassword: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'blur'},
          {validator: this.passwordCharsRule, trigger: 'blur'},
          {validator: this.passwordsResetMatchRule, trigger: 'blur'}
        ],
        pin: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'blur'},
          {validator: this.validateOnly6Numbers, trigger: 'blur'}
        ]
      },
      odstraniSProjektaConfirm: false,
      loadingRemoveUserFromProject: false,
      loadingPosljiPin: false,
      loadingResetPassword: false,
      loadingChangePassword: false,
      loadingChangeData: false
    }
  },
  computed: {
    removeUserFromProjectConfirmButton () {
      return this.loadingRemoveUserFromProject
        ? 'Odstranjujem uporabnika s projekta'
        : 'DA, odstrani uporabnika s projekta'
    }
  },
  methods: {
    passwordsMatchRule (rule, value, callback) {
      if (value !== this.passChange.newPassword) {
        callback(new Error('Polje se mora ujemati z Novim geslom'))
      } else {
        callback()
      }
    },
    passwordsResetMatchRule (rule, value, callback) {
      if (value !== this.passReset.newPassword) {
        callback(new Error('Polje se mora ujemati z Novim geslom'))
      } else {
        callback()
      }
    },
    passwordCharsRule (rule, value, callback) {
      let re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!,$.?\\/{}*+\\-<>@#"%&()=\'_\\[\\]÷\\\\|;:€łŁ~¸§×¤ß°¨])[\\w!,$.?\\/{}*+\\-<>@#"%&()=\'_\\[\\]÷\\\\|;:€łŁ~¸§×¤ß°¨]{8,50}$')
      if (!re.test(value)) {
        callback(new Error('Min 8 znakov. Vsaj 1 znak, številko, veliko in malo črko!'))
      } else {
        callback()
      }
    },
    validateOnly6Numbers (rule, value, callback) {
      let re = new RegExp('^[0-9]{6}$')
      if (!re.test(value)) {
        callback(new Error('Vnesite 6 številk'))
      } else {
        callback()
      }
    },
    async posliPin () {
      try {
        this.loadingPosljiPin = true
        await this.user.sendPasswordResetPin()
        this.loadingPosljiPin = false
        this.ShowSuccessMessage({message: 'Pin uspešno poslan'})
        this.pinPoslan = new Date().getTime()
        this.pinInterval = setInterval(function () {
          let curTime = new Date().getTime()
          let resetTime = 600000
          if ((curTime - resetTime) > this.pinPoslan) {
            clearInterval(this.pinInterval)
            this.pinInterval = null
            this.pinPoslan = null
            this.pinRenewLabel = ''
          }
          let label = Math.round((curTime - this.pinPoslan - resetTime) / -1000)
          if (label > resetTime || (label * -1) > resetTime) {
            label = ''
          } else {
            let min = Math.floor(label / 60)
            label = (min !== 0 ? min + ':' : '') + ('0' + (label - (min * 60))).substr(-2) + ' s'
          }
          this.pinRenewLabel = label
        }.bind(this), 1000)
      } catch (e) {
        this.loadingPosljiPin = false
        this.ShowErrorMessage(this.getMessageFromResponse(e))
      }
    },
    async submitFormDataChange () {
      this.$refs['dataChangeForm'].validate(async (valid) => {
        if (valid) {
          try {
            this.loadingChangeData = true
            await this.user.changeData(this.dataChange)
            this.ShowSuccessMessage({message: 'Podatki uspešno spremenjeni'})
          } catch (e) {
            this.ShowErrorMessage(this.getMessageFromResponse(e))
          }
          this.loadingChangeData = false
        } else {
          return false
        }
      })
    },
    submitFormPassChange () {
      this.$refs['passChangeForm'].validate(async (valid) => {
        if (valid) {
          try {
            this.loadingChangePassword = true
            await this.user.changePassword(this.passChange.oldPassword, this.passChange.newPassword)
            this.loadingChangePassword = false
            this.ShowSuccessMessage({message: 'Geslo uspešno spremenjeno'})
            this.resetForm('passChangeForm')
          } catch (e) {
            this.ShowErrorMessage(this.getMessageFromResponse(e))
            this.loadingChangePassword = false
          }
        } else {
          return false
        }
      })
    },
    submitFormPassReset () {
      this.$refs['passResetForm'].validate(async (valid) => {
        if (valid) {
          try {
            this.loadingResetPassword = true
            await this.user.resetPassword(this.passReset.newPassword, this.passReset.pin)
            this.ShowSuccessMessage({message: 'Geslo uspešno ponastavljeno'})
            this.ponastaviGesloDetails = false
            this.loadingResetPassword = false
            this.resetForm('passResetForm')
            if (this.pinInterval !== null) {
              clearInterval(this.pinInterval)
              this.pinInterval = null
              this.pinPoslan = null
              this.pinRenewLabel = ''
            }
          } catch (e) {
            this.loadingResetPassword = false
            this.ShowErrorMessage(this.getMessageFromResponse(e))
          }
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    async odstraniUporabnikaSProjekta () {
      if (this.project !== null) {
        try {
          this.loadingRemoveUserFromProject = true
          await this.project.removeUserFromProject(this.user)
          this.$emit('userRemovedFromProject')
          this.loadingRemoveUserFromProject = false
          this.ShowSuccessMessage({
            message: `Uporabnik ${this.user.username} uspešno odstranjen s projekta ${this.project.name}`
          })
        } catch (e) {
          this.ShowErrorMessage(this.getMessageFromResponse(e))
        }
      } else {
        this.ShowErrorMessage({message: 'Ne najdem projekta'})
      }
    },
    getMessageFromResponse (e) {
      let message = e.message
      if (e.response !== undefined && e.response.data !== undefined && e.response.data.message !== undefined) {
        message = e.response.data.message
      }
      return {message: message}
    }
  }
}
</script>

<style scoped>
#odstraniUporabnikaSProjekta {
  background-color: #fdefea;
  color: #EB5E28;
  border-left: 5px solid #EB5E28;
  padding: 10px 20px;
  border-radius: 3px;
  margin-bottom: 25px
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/T2Cloud/CloudUserEdit.vue